/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SkillFilterSchemaMode } from './skillFilterSchemaMode';

export interface SkillFilterSchema {
  variants?: string[] | null;
  canonical_id?: number | null;
  text?: string | null;
  required?: boolean;
  mode?: SkillFilterSchemaMode;
}
